module.exports = __webpack_public_path__ + "assets/img/Yoobic-Landing-Page-+-Website-w720.1c12d87f.webp";